import useToastedMutation from '../../../ReactQuery/useToastedMutation';
import { post } from '../../../redux/api';

async function backfillIssueSanitizedLocators(): Promise<void> {
  await post('/api/organizations/backfill-issue-sanitized-locators', {});
}

/**
 * Hook to backfill issue sanitized locator data for the current organization.
 * @returns Mutation function to trigger issue sanitized locators backfill
 */
export const useBackfillIssueSanitizedLocators = () => {
  return useToastedMutation({
    mutationFn: backfillIssueSanitizedLocators,
    successToastMessage: 'Issue sanitized locators backfill queued successfully',
    errorToastMessage: 'Failed to queue issue sanitized locators backfill',
  });
};
